import React, { useEffect } from 'react';
import { NamedLink, ExternalLink, LayoutComposer, Heading } from '../../components';

import StaticPage from '../PageBuilder/StaticPage';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import css from './ContactPage.module.css';

const ContactPage = () => {
  const layoutAreas = `
    topbar
    main
    footer
  `;

  return (
    <StaticPage
      className={css.root}
      title="Contact Us | Sweettooth"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'SocialMediaPage',
        description: 'Contact Us',
        name: 'Contact Sweettooth',
      }}
    >
      <LayoutComposer areas={layoutAreas} className={css.layout}>
        {() => (
          <>
            <TopbarContainer />
            <div className={css.maincontainer}>
              <h3>Shoot your questions below!</h3>
              <iframe
                src="https://app.youform.com/forms/t3lnakmn"
                loading="lazy"
                width="100%"
                height="700"
                frameborder="0"
                marginheight="0"
                marginwidth="0"
              ></iframe>
              <br />
              <br />
              <h3>Contact Us</h3>
              <p>Email: Hello@usesweettooth.com</p>
              <p>Customer Support: (424)-354-9992</p>
            </div>
            <FooterContainer />
          </>
        )}
      </LayoutComposer>
    </StaticPage>
  );
};

export default ContactPage;
